import { showLoading } from 'react-global-loading';
import { toast } from 'react-toastify';
import messages from '../assets/Messages.json';

export async function confirmAndDelete(options) {
  const {
    message,
    deleteApiCall,
    onSuccess,
    onError,
    showLoadingDuringCall = true,
    successMessage,
  } = options || {};

  if (!message || typeof deleteApiCall !== 'function') {
    console.warn('confirmAndDelete: message and deleteApiCall are required');
    return false;
  }

  const confirmed = window.confirm(message);
  if (!confirmed) return false;

  if (showLoadingDuringCall) {
    showLoading(true);
  }

  try {
    const response = await deleteApiCall();
    const status = response?.data?.status ?? response?.status === 200;
    if (status) {
      if (typeof onSuccess === 'function') onSuccess(response);
      toast.success(successMessage ?? response?.data?.message ?? 'Deleted successfully', messages.COLOR_RED);
      return true;
    } else {
      const errMsg = response?.data?.message || 'Delete failed';
      if (typeof onError === 'function') onError(new Error(errMsg));
      else toast.error(errMsg, messages.COLOR_RED);
      return false;
    }
  } catch (error) {
    const errMsg = error.response?.data?.message || error.message || 'Failed to delete';
    if (typeof onError === 'function') onError(error);
    else toast.error(errMsg, messages.COLOR_RED);
    return false;
  } finally {
    if (showLoadingDuringCall) {
      showLoading(false);
    }
  }
}
